module.exports = __webpack_public_path__ + "static/media/services-mobile-bg-1.5efa048b.svg";